import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbRow } from '../../types/pbBlocks';
import {
    getAdvanced,
    getBackgroundImages,
    getBackgroundImagesForLozad,
    parseStyleString,
    getVideoOptions,
    getParallaxOptions,
    getIsHidden,
} from '../utils';

export type RowType = ContentTypeObject & PbRow;

/**
 * Aggregates the configuration of a row element.
 * @param node
 * @param props
 */
export function rowConfigAggregator(node: CustomHtmlElement, props: ContentTypeObject): RowType {
    const isContainer = props.appearance === 'contained';

    /**
     * If the row is a container, the first child node is the actual row.
     * this row will contain the remaining attributes used to get style/component data .
     */
    const childNode = node.childNodes[0];
    const dataNode = isContainer ? childNode : node;

    const style = parseStyleString(dataNode.attributes.style);
    const isHiddenStyle = parseStyleString(node.attributes.style);

    // Extract background images for lozad lazy loading (separate from styles)
    const backgroundImages = getBackgroundImagesForLozad(dataNode);

    return {
        ...getAdvanced(dataNode, style),
        ...getIsHidden(isHiddenStyle),
        ...getBackgroundImages(dataNode, style),
        ...getVideoOptions(dataNode),
        ...getParallaxOptions(dataNode),
        // Add the images as separate properties for lozad
        desktopImage: backgroundImages.desktopImage,
        mobileImage: backgroundImages.mobileImage,
        appearance: props.appearance,
        backgroundType: dataNode.attributes['data-background-type'],
        minHeight: style?.minHeight,
        uniqueID: dataNode.attributes['data-pb-style'],
        verticalAlignment: style?.justifyContent,
    };
}
